import { render, staticRenderFns } from "./CanadasDeptos.vue?vue&type=template&id=abb7843c"
import script from "./CanadasDeptos.vue?vue&type=script&lang=js"
export * from "./CanadasDeptos.vue?vue&type=script&lang=js"
import style0 from "./CanadasDeptos.vue?vue&type=style&index=0&id=abb7843c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports